"use client";
import SvgMobileWordmark from "./mobile_wordmark.svg.js";
import SvgBergeWordmark from "./berge_wordmark.svg.js";
import SvgFremmeWordmark from "./fremme_wordmark.svg.js";
import SvgSlatlemWordmark from "./slatlem_wordmark.svg.js";
import SvgSullandWordmark from "./sulland_wordmark.svg.js";
import SvgAltaWordmark from "./alta_wordmark.svg.js";
import SvgSvebjornWordmark from "./svebjorn_wordmark.svg.js";
import SvgAlbjerkWordmark from "./albjerk_wordmark.svg.js";
import SvgKirkenesWordmark from "./kirkenes_wordmark.svg.js";
const berge = {
  key: "berge",
  symbol: SvgBergeWordmark,
  wordmark: SvgBergeWordmark
};
const fremme = {
  key: "fremme",
  symbol: SvgFremmeWordmark,
  wordmark: SvgFremmeWordmark
};
const sulland = {
  key: "sulland",
  symbol: SvgSullandWordmark,
  wordmark: SvgSullandWordmark
};
const slatlem = {
  key: "slatlem",
  symbol: SvgSlatlemWordmark,
  wordmark: SvgSlatlemWordmark
};
const albjerk = {
  key: "albjerk",
  symbol: SvgAlbjerkWordmark,
  wordmark: SvgAlbjerkWordmark
};
const kirkenes = {
  key: "kirkenes",
  symbol: SvgKirkenesWordmark,
  wordmark: SvgKirkenesWordmark
};
const alta = {
  key: "alta",
  symbol: SvgAltaWordmark,
  wordmark: SvgAltaWordmark
};
const svebjorn = {
  key: "svebjorn",
  symbol: SvgSvebjornWordmark,
  wordmark: SvgSvebjornWordmark
};
const mobile = {
  key: "mobile",
  symbol: SvgMobileWordmark,
  wordmark: SvgMobileWordmark
};
export {
  albjerk,
  alta,
  berge,
  fremme,
  kirkenes,
  mobile,
  slatlem,
  sulland,
  svebjorn
};
